import React, { useState, useEffect, useMemo } from 'react';
// import MaterialTable from 'material-table'
import MUIDataTable from 'mui-datatables';
import { useHistory } from 'react-router';
import { safeGet } from '../../axios-default';

import { Close as CloseIcon, Check as CheckIcon, StarRate } from '@material-ui/icons';
import useAuth from '../../hooks/useAuth';
import { ROLE_NAMES } from '../../util/const';

export const AccountsTable = () => {
    const history = useHistory();
    const { user } = useAuth();

    const [loading, setLoading] = useState(true),
        [accounts, setAccounts] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { user: data } = await safeGet(`user/accounts`);
                if (loading) setLoading(false);
                setAccounts(data.filter(({ deleted_flag }) => !deleted_flag));
            } catch (err) {
                console.error(err);
            }
        })();
    }, []);

    const allowDownload = useMemo(() => {
        if (!user || !user.role) return false;
        return user.role !== ROLE_NAMES.super_admin;
    }, [user.role]);

    return (
        <MUIDataTable
            title="Accounts List"
            data={accounts}
            columns={[
                {
                    name: 'user_id',
                    label: 'Account ID',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'role',
                    label: 'Role',
                    options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value, tableMeta) => (
                            <>
                                {tableMeta.rowData.admin_flag ? <StarRate style={{ verticalAlign: 'bottom' }} /> : null}
                                {value}
                            </>
                        ),
                    },
                },
                {
                    name: 'first_name',
                    label: 'First Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'last_name',
                    label: 'Last Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'approved_flag',
                    label: 'Approved',
                    options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value) => (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    margin: '0px 4px',
                                    width: 40,
                                    height: 40,
                                }}
                            >
                                {value ? <CheckIcon /> : <CloseIcon />}
                            </div>
                        ),
                    },
                },
                {
                    name: 'active_flag',
                    label: 'Active',
                    options: {
                        filter: true,
                        sort: true,
                        customBodyRender: (value) => (
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    margin: '0px 4px',
                                    width: 40,
                                    height: 40,
                                }}
                            >
                                {value ? <CheckIcon /> : <CloseIcon />}
                            </div>
                        ),
                    },
                },
                {
                    name: 'email_address',
                    label: 'Email',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'distr_group_name',
                    label: 'DistrGroup Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'clinic_name',
                    label: 'Clinic Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'group_name',
                    label: 'Group Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'group_distrgroup_name',
                    label: 'Group DistrGroup Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'admin_group_name',
                    label: 'AdminGroup Name',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'country_name',
                    label: 'Country',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
                {
                    name: 'state_province_name',
                    label: 'State / Province',
                    options: {
                        filter: true,
                        sort: true,
                    },
                },
            ]}
            options={{
                download: allowDownload,
                filterType: 'dropdown',
                print: false,
                responsive: 'scroll',
                rowsPerPage: 30,
                rowsPerPageOptions: [10, 15, 30, 50, 100],
                onRowClick: (data) => {
                    history.push(`/admin/accounts/${data[0]}`);
                },
                selectableRows: false,
                sortOrder: { name: 'approved_flag', direction: 'asc' },
            }}
        />
    );
};

export default AccountsTable;
